export default __webpack_public_path__ + "static/media/cloudy.f01a587e.svg";